import { render, staticRenderFns } from "./BookingNotesComponent.vue?vue&type=template&id=2927707d"
import script from "./BookingNotesComponent.vue?vue&type=script&lang=js"
export * from "./BookingNotesComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports